import { Text } from 'features/common/components/Text';
import styled from 'styled-components';

export const Wrapper = styled.div``;

export const Title = styled(Text)`
	color: ${({ theme }) => theme.colors.black};
`;

export const Date = styled.p`
	font-family: ${({ theme }) => theme.fonts.primary};
	font-size: 14px;
	line-height: 21px;
	color: ${({ theme }) => theme.colors.black};
`;

export const Location = styled(Date)`
	display: flex;
	align-items: center;
	gap: 10px;
	text-decoration: underline;
	cursor: pointer;
	color: ${({ theme }) => theme.colors.black};
`;
